import { render, staticRenderFns } from "./handle.vue?vue&type=template&id=286eca17&scoped=true"
import script from "./handle.vue?vue&type=script&lang=js"
export * from "./handle.vue?vue&type=script&lang=js"
import style0 from "./handle.vue?vue&type=style&index=0&id=286eca17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286eca17",
  null
  
)

export default component.exports